import clusterLogo from '../assets/clubs/cluster/logo.png'

/**
 * Club branding — configure per deployment via REACT_APP_CLUB_* env vars.
 *
 * To onboard a new club:
 * 1. Add `src/assets/clubs/<club-id>/logo.png`
 * 2. Register the logo in `bundledLogos` below
 * 3. Set REACT_APP_CLUB_ID=<club-id> and other REACT_APP_CLUB_* vars in .env
 *
 * Access env keys with static `process.env.REACT_APP_*` expressions so webpack
 * DefinePlugin can bake values into the web build.
 */
const bundledLogos: Record<string, string | number> = {
    cluster: clusterLogo,
}

export const clubBranding = {
    id: process.env.REACT_APP_CLUB_ID || 'cluster',
    /** Shown below the logo when set; leave empty if the logo already includes the club name */
    name: process.env.REACT_APP_CLUB_NAME || '',
    /** Shown below the logo when set; leave empty if the logo already includes a tagline */
    tagline: process.env.REACT_APP_CLUB_TAGLINE || '',
    splashBackground: process.env.REACT_APP_CLUB_SPLASH_BG || '#000000',
    appTitle: process.env.REACT_APP_CLUB_APP_TITLE || 'Cluster',
    logoUrl: process.env.REACT_APP_CLUB_LOGO_URL || '',
    contactPhone: process.env.REACT_APP_CLUB_CONTACT_PHONE || '',
    instagramUrl: process.env.REACT_APP_CLUB_INSTAGRAM || '',
    telegramUrl: process.env.REACT_APP_CLUB_TELEGRAM || '',
    telegramChatUrl: process.env.REACT_APP_CLUB_TELEGRAM_CHAT || '',
    /**
     * Walk-in registration bot (not the club channel). Matches backend TELEGRAM_BOT_USERNAME.
     * Guard `process` so a stale webpack-dev-server (started before this env was in DefinePlugin)
     * does not crash the browser with "process is not defined".
     */
    telegramBotUsername:
        (typeof process !== 'undefined' && process.env.REACT_APP_TELEGRAM_BOT_USERNAME)
        || 'Cluster_palace_bot',
}

/** Opens the bot walk-in flow (`/start register`). */
export function telegramRegisterBotUrl(): string {
    const username = clubBranding.telegramBotUsername.replace(/^@/, '').trim()
    return `https://t.me/${username}?start=register`
}

export function getClubLogoSource(): { uri: string } | number {
    if (clubBranding.logoUrl) {
        return { uri: clubBranding.logoUrl }
    }
    const bundled = bundledLogos[clubBranding.id] ?? bundledLogos.cluster
    return typeof bundled === 'string' ? { uri: bundled } : bundled
}

/** `tel:` href from a display phone (keeps leading +, strips other non-digits). */
export function clubPhoneTelHref(phone: string): string {
    const cleaned = phone.replace(/[^\d+]/g, '')
    return cleaned ? `tel:${cleaned}` : ''
}
